import { createContext, useContext } from "react";

/**
 * False only for the homepage PaidStudentHome keeps loaded, hidden, behind the
 * one on screen. Every other render of a homepage (StudentPortal's dashboard,
 * /sp-dashboard, students without the switch) has no provider and gets true.
 */
export const HomepageActiveContext = createContext(true);

/**
 * Whether this homepage is the one the student is looking at. Effects a student
 * should see or that count as "they saw it" (popups, one-time hints, landing
 * analytics, payment-return handling) wait for it, so a preloaded homepage stays
 * silent until the student switches to it.
 *
 * @returns {boolean}
 */
const useHomepageActive = () => useContext(HomepageActiveContext);

export default useHomepageActive;
